/*
 * Coordinates background videos with the theme's existing Flickity slideshow.
 * Only the visible video in the selected slide plays; all others stay paused.
 */
(function () {
  'use strict';

  var controllers = {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function isVisible(video) {
    var frame = video.closest('.slideshow__video-frame');
    return frame && window.getComputedStyle(frame).display !== 'none';
  }

  function SlideshowVideos(section, themeSlider) {
    this.section = section;
    this.slider = themeSlider;
    this.flickity = themeSlider.flkty;
    this.videos = Array.prototype.slice.call(section.querySelectorAll('.slideshow__video'));
    this.controls = Array.prototype.slice.call(section.querySelectorAll('[data-slideshow-video-control]'));
    this.activeVideo = null;
    this.inViewport = true;
    this.resizeTimer = null;

    this.sync = this.sync.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onControlClick = this.onControlClick.bind(this);

    this.videos.forEach(function (video) {
      video.muted = true;
      video.playsInline = true;
    });

    this.flickity.on('change', this.sync);
    this.flickity.on('settle', this.sync);
    document.addEventListener('visibilitychange', this.sync);
    window.addEventListener('resize', this.onResize);

    this.controls.forEach(function (control) {
      control.addEventListener('click', this.onControlClick);
    }, this);

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(function (entries) {
        this.inViewport = entries[0].isIntersecting;
        this.sync();
      }.bind(this));
      this.observer.observe(this.section);
    }

    if (typeof reduceMotion.addEventListener === 'function') {
      reduceMotion.addEventListener('change', this.sync);
    } else if (typeof reduceMotion.addListener === 'function') {
      reduceMotion.addListener(this.sync);
    }

    this.sync();
  }

  SlideshowVideos.prototype.onResize = function () {
    window.clearTimeout(this.resizeTimer);
    this.resizeTimer = window.setTimeout(this.sync, 100);
  };

  SlideshowVideos.prototype.onControlClick = function (event) {
    event.preventDefault();
    event.stopPropagation();

    var slide = event.currentTarget.closest('[data-slide]');
    var pausedByUser = slide.getAttribute('data-video-paused') === 'true';

    slide.setAttribute('data-video-paused', pausedByUser ? 'false' : 'true');
    this.sync();
  };

  SlideshowVideos.prototype.sync = function () {
    var selectedSlide = this.section.querySelector('[data-slide].is-selected');
    var canPlay = !reduceMotion.matches && !document.hidden && this.inViewport;
    var nextVideo = null;

    this.videos.forEach(function (video) {
      var slide = video.closest('[data-slide]');
      var pausedByUser = slide.getAttribute('data-video-paused') === 'true';
      var shouldPlay = canPlay && !pausedByUser && slide === selectedSlide && isVisible(video);

      if (shouldPlay && nextVideo === null) {
        nextVideo = video;
      } else {
        video.pause();
      }
    });

    this.controls.forEach(function (control) {
      var slide = control.closest('[data-slide]');
      var visibleVideo = this.videos.some(function (video) {
        return video.closest('[data-slide]') === slide && isVisible(video);
      });
      var pausedByUser = slide.getAttribute('data-video-paused') === 'true';
      var label = pausedByUser ? 'Play video' : 'Pause video';

      control.hidden = reduceMotion.matches || !visibleVideo || slide !== selectedSlide;
      control.setAttribute('aria-label', label);
      control.querySelector('[data-slideshow-video-control-label]').textContent = label;
    }, this);

    if (nextVideo === this.activeVideo) {
      if (nextVideo && nextVideo.paused) {
        var resumePromise = nextVideo.play();
        if (resumePromise && typeof resumePromise.catch === 'function') {
          resumePromise.catch(function () {});
        }
      }
      return;
    }

    this.activeVideo = nextVideo;

    if (nextVideo) {
      try {
        nextVideo.currentTime = 0;
      } catch (error) {
        // Some browsers reject seeking until video metadata is available.
      }

      var playPromise = nextVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }
  };

  SlideshowVideos.prototype.destroy = function () {
    window.clearTimeout(this.resizeTimer);

    if (this.flickity) {
      this.flickity.off('change', this.sync);
      this.flickity.off('settle', this.sync);
    }

    document.removeEventListener('visibilitychange', this.sync);
    window.removeEventListener('resize', this.onResize);

    this.controls.forEach(function (control) {
      control.removeEventListener('click', this.onControlClick);
    }, this);

    if (this.observer) {
      this.observer.disconnect();
    }

    if (typeof reduceMotion.removeEventListener === 'function') {
      reduceMotion.removeEventListener('change', this.sync);
    } else if (typeof reduceMotion.removeListener === 'function') {
      reduceMotion.removeListener(this.sync);
    }

    this.videos.forEach(function (video) {
      video.pause();
    });
  };

  document.addEventListener('slider-is-loaded', function (event) {
    var section = event.target.closest('[data-section-type="slideshow"]');
    var themeSlider = event.detail && event.detail.slider;

    if (!section || !themeSlider || !themeSlider.flkty || !section.querySelector('.slideshow__video')) {
      return;
    }

    var sectionId = section.getAttribute('data-section-id');
    if (controllers[sectionId]) {
      controllers[sectionId].destroy();
    }

    controllers[sectionId] = new SlideshowVideos(section, themeSlider);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var sectionId = event.detail && event.detail.sectionId;

    if (sectionId && controllers[sectionId]) {
      controllers[sectionId].destroy();
      delete controllers[sectionId];
    }
  });
})();